<template>
  <div>
    <h1>Why is Lawn Treatment Important?</h1>
    <div class="has-text-centered">
      <figure class="image is-129x85 is-inline-block">
        <img :src="require('@/assets/lawn_treatment/grass.png')" />
      </figure>
      <ul>
        <li>Lawn treatment strengthens grass and its root system</li>
        <li>Make your lawn less vulnerable to weeds, disease and more resistant to pests</li>
        <li>Lawn treatment will improve grass growth and protect its soil</li>
      </ul>
      <LsButton
        text="Schedule Service"
        track-id="add_lawn_treatment-advance_step"
        :is-uppercase="false"
        bg-color="primary"
        class="add-lt block"
        @click="$emit('advanceStep')"
      />
      <br />
      <RouterLink :to="{ name: 'services' }">Return to Schedule</RouterLink>
    </div>
  </div>
</template>

<script>
import LsButton from '@/components/common/LsButton/LsButton.vue';

export default {
  name: 'LawnTreatmentWhyViewComponent',
  components: { LsButton },
};
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 40px;
}

ul {
  font-size: 16px;
  line-height: 24px;
  list-style-type: disc;
  margin: 40px 0 40px 20px;
  max-width: 440px;
  text-align: left;
}

a {
  color: black;

  &:hover {
    text-decoration: underline;
  }
}

.add-lt {
  min-width: 272px;
  height: 40px;
}
</style>
